import { API_URL } from "./config.js";
import { getToken, requireAuth } from "./auth.js";

document.addEventListener("DOMContentLoaded", () => {
  if (!requireAuth()) return;

  const calculoRadios = document.querySelectorAll('input[name="calculo"]');
  const empresaRadios = document.querySelectorAll('input[name="empresa"]');
  const trackingEmpresaRadios = document.querySelectorAll(
    'input[name="trackingEmpresa"]',
  );

  const title = document.getElementById("main-title");
  const facturaLabel = document.getElementById("factura-label");
  const tarifasLabel = document.getElementById("tarifas-label");
  const trackingLabel = document.getElementById("tracking-label");

  const empresaWrapper = document.getElementById("empresa-wrapper");
  const trackingEmpresaWrapper = document.getElementById(
    "tracking-empresa-wrapper",
  );

  const facturaWrapper = facturaLabel?.closest("label") || null;
  const trackingWrapper = trackingLabel?.closest("label") || null;
  const wooWrapper = document.getElementById("woocommerce-wrapper");
  const tarifasWrapper = tarifasLabel?.closest("label") || null;
  const canparFacturaWrapper = document.getElementById(
    "canpar-factura-wrapper",
  );
  const shipstationWrapper = document.getElementById("shipstation-wrapper");
  const ratesWrapper = document.getElementById("rates-wrapper");
  const trackingShipstationWrapper = document.getElementById(
    "tracking-shipstation-wrapper",
  );
  const trackingFileWrapper = document.getElementById("tracking-file-wrapper");
  const trackingBulkWrapper = document.getElementById("tracking-bulk-wrapper");
  const trackingOpenPopupBtn = document.getElementById(
    "tracking-open-popup-btn",
  );
  const submitBtn = document.getElementById("main-submit-btn");

  const form = document.getElementById("main-form");
  const spinner = document.getElementById("spinner-overlay");

  const fletesTitles = {
    Fedex: "Revisión de Fletes Fedex",
    DHL: "Revisión de Fletes DHL",
    Canpar: "Revisión de Fletes Canpar",
  };

  const trackingTitles = {
    CP: "Revisión de Tracking CP",
    CANPAR: "Tracking Canpar",
  };

  function getCalculoSeleccionado() {
    return document.querySelector('input[name="calculo"]:checked')?.value;
  }

  function getEmpresaSeleccionada() {
    return document.querySelector('input[name="empresa"]:checked')?.value;
  }

  function getTrackingEmpresaSeleccionada() {
    return document.querySelector('input[name="trackingEmpresa"]:checked')
      ?.value;
  }

  function updateFletesFields(empresa) {
    const isCanpar = empresa === "Canpar";

    facturaWrapper?.classList.toggle("hidden", isCanpar);
    trackingWrapper?.classList.toggle("hidden", isCanpar);
    tarifasWrapper?.classList.toggle("hidden", isCanpar);
    wooWrapper?.classList.toggle("hidden", isCanpar);

    canparFacturaWrapper?.classList.toggle("hidden", !isCanpar);
    shipstationWrapper?.classList.toggle("hidden", !isCanpar);
    ratesWrapper?.classList.toggle("hidden", !isCanpar);

    trackingShipstationWrapper?.classList.add("hidden");
    trackingFileWrapper?.classList.add("hidden");
    trackingBulkWrapper?.classList.add("hidden");

    if (!isCanpar) {
      facturaLabel.textContent = `Factura ${empresa}`;
      tarifasLabel.textContent = `Tarifas ${empresa}`;
      trackingLabel.textContent = "Tracking";
    }
  }

  function updateTrackingFields() {
    const trackingEmpresa = getTrackingEmpresaSeleccionada() || "CP";

    facturaWrapper?.classList.add("hidden");
    trackingWrapper?.classList.add("hidden");
    tarifasWrapper?.classList.add("hidden");
    wooWrapper?.classList.add("hidden");

    canparFacturaWrapper?.classList.add("hidden");
    shipstationWrapper?.classList.add("hidden");
    ratesWrapper?.classList.add("hidden");

    trackingShipstationWrapper?.classList.toggle(
      "hidden",
      trackingEmpresa !== "CP",
    );
    trackingFileWrapper?.classList.toggle("hidden", trackingEmpresa !== "CP");
    trackingBulkWrapper?.classList.toggle(
      "hidden",
      trackingEmpresa !== "CANPAR",
    );
  }

  function updateView() {
    const calculo = getCalculoSeleccionado() || "Fletes";

    if (calculo === "Tracking") {
      empresaWrapper?.classList.add("hidden");
      trackingEmpresaWrapper?.classList.remove("hidden");
      updateTrackingFields();
      const trackingEmpresa = getTrackingEmpresaSeleccionada() || "CP";
      title.textContent =
        trackingTitles[trackingEmpresa] || "Revisión de Tracking";
      if (submitBtn) {
        submitBtn.textContent =
          trackingEmpresa === "CANPAR"
            ? "Importar registros"
            : "Iniciar análisis";
      }
      return;
    }

    empresaWrapper?.classList.remove("hidden");
    trackingEmpresaWrapper?.classList.add("hidden");

    const empresa = getEmpresaSeleccionada() || "Fedex";
    updateFletesFields(empresa);
    title.textContent = fletesTitles[empresa] || "Revisión de Fletes";
    if (submitBtn) {
      submitBtn.textContent = "Iniciar análisis";
    }
  }

  calculoRadios.forEach((radio) => {
    radio.addEventListener("change", updateView);
  });

  empresaRadios.forEach((radio) => {
    radio.addEventListener("change", updateView);
  });

  trackingEmpresaRadios.forEach((radio) => {
    radio.addEventListener("change", updateView);
  });

  trackingOpenPopupBtn?.addEventListener("click", () => {
    if (!requireAuth()) return;

    window.carrierTrackingPopup?.open({
      carrier: "CANPAR",
      title: trackingTitles.CANPAR,
    });
  });

  updateView();

  async function descargarResultado(res, prefijoNombre, valor) {
    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    const now = new Date();
    try {
      const options = {
        timeZone: "America/Bogota",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      };
      const fechaColombia = now
        .toLocaleString("sv-SE", options)
        .replace(/\D/g, "-");
      a.download = `${prefijoNombre}-${valor}-${fechaColombia}.xlsx`;
    } catch {
      a.download = `${prefijoNombre}-${valor}.xlsx`;
    }

    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }

  form?.addEventListener("submit", async (event) => {
    event.preventDefault();
    if (!requireAuth()) return;

    const calculo = getCalculoSeleccionado() || "Fletes";
    const formData = new FormData();
    let endpoint = `${API_URL}/analisis`;
    let archivoNombre = "Revision-flete";
    let valorNombre = "";
    let expectsDownload = true;

    if (calculo === "Tracking") {
      const trackingEmpresa = getTrackingEmpresaSeleccionada() || "CP";
      if (trackingEmpresa === "CANPAR") {
        const trackingFiles = Array.from(
          form.elements.trackingBulkFiles.files || [],
        );

        if (!trackingFiles.length) {
          window.showSnackbar?.(
            "Debes seleccionar uno o más archivos Excel o CSV para importar registros.",
            "error",
          );
          return;
        }

        endpoint = `${API_URL}/carrier-tracking/import`;
        valorNombre = trackingEmpresa;
        expectsDownload = false;

        formData.append("carrier", trackingEmpresa);
        trackingFiles.forEach((file) => {
          formData.append("trackingFiles", file);
        });
      } else {
        const shipstationFile = form.elements.trackingShipstation.files[0];
        const trackingFile = form.elements.trackingArchivo.files[0];

        if (!shipstationFile || !trackingFile) {
          window.showSnackbar?.(
            "Debes seleccionar Shipstation y Tracking para iniciar el análisis.",
            "error",
          );
          return;
        }

        endpoint = `${API_URL}/tracking`;
        archivoNombre = "Revision-tracking";
        valorNombre = trackingEmpresa;

        formData.append("empresa", trackingEmpresa);
        formData.append("shipstation", shipstationFile);
        formData.append("tracking", trackingFile);
      }
    } else {
      const empresa = getEmpresaSeleccionada() || "Fedex";
      valorNombre = empresa;

      if (empresa === "Canpar") {
        const canparFiles = [
          form.elements.canparFactura.files[0],
          form.elements.shipstation.files[0],
          form.elements.rates.files[0],
        ];

        if (canparFiles.some((file) => !file)) {
          window.showSnackbar?.(
            "Debes seleccionar los 3 archivos para Canpar.",
            "error",
          );
          return;
        }

        formData.append("empresa", empresa);
        formData.append("canparFactura", form.elements.canparFactura.files[0]);
        formData.append("shipstation", form.elements.shipstation.files[0]);
        formData.append("rates", form.elements.rates.files[0]);
      } else {
        const files = [
          form.elements.factura.files[0],
          form.elements.tracking.files[0],
          form.elements.woocommerce.files[0],
          form.elements.tarifas.files[0],
        ];

        if (files.some((file) => !file)) {
          window.showSnackbar?.(
            "Debes seleccionar los 4 archivos para iniciar el análisis.",
            "error",
          );
          return;
        }

        formData.append("empresa", empresa);
        formData.append("factura", form.elements.factura.files[0]);
        formData.append("tracking", form.elements.tracking.files[0]);
        formData.append("woocommerce", form.elements.woocommerce.files[0]);
        formData.append("tarifas", form.elements.tarifas.files[0]);
      }
    }

    spinner?.classList.remove("hidden");
    try {
      const token = getToken();
      const res = await fetch(endpoint, {
        method: "POST",
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        body: formData,
      });

      if (res.ok) {
        if (expectsDownload) {
          await descargarResultado(res, archivoNombre, valorNombre);
          window.showSnackbar?.(
            "Archivo generado y descargado correctamente.",
            "success",
          );
        } else {
          const result = await res.json();
          window.showSnackbar?.(
            `Importación completada. Nuevos: ${result.insertedCount}. Omitidos: ${result.skippedCount}.`,
            "success",
          );
          form.elements.trackingBulkFiles.value = "";
          window.carrierTrackingPopup?.open({
            carrier: valorNombre,
            title: trackingTitles[valorNombre] || "Tracking",
          });
        }
      } else {
        let message = "Error al enviar archivos.";
        try {
          const error = await res.json();
          const details = error.details ? ` (${error.details})` : "";
          const requestId = error.requestId ? ` [ID: ${error.requestId}]` : "";
          message = `${error.error || message}${details}${requestId}`;
        } catch {
          if (calculo === "Tracking" && res.status === 404) {
            message =
              "El módulo de Tracking aún no está disponible en backend.";
          }
        }
        window.showSnackbar?.(message, "error");
      }
    } catch {
      window.showSnackbar?.("Error de red o del servidor.", "error");
    } finally {
      spinner?.classList.add("hidden");
    }
  });
});
